/**
 * @module interface
 */
export interface V2TimFriendSearchParam {
    keywordList: string[];
    isSearchUserID?: Boolean;
    isSearchNickName?: Boolean;
    isSearchRemark?: Boolean;
}
